<div class="prompt-box-container">
  <div class="prompt-box" [class.generating]="generating()">
    <form [formGroup]="form" (ngSubmit)="submit()">
      <div class="textarea-container">
        <div
          class="textarea"
          #promptInputEl
          name="new-thread"
          contenteditable
          [(wysiwyg)]="promptInput"
          [allowHtml]="false"
          (input)="updatePrompt()"
          appAutofocus
        ></div>
        @if (!promptInput.length) {
          <div class="placeholder">Type to generate images...</div>
        }
      </div>

      <div class="prompt-footer">
        <app-switcher
          name="model"
          location="image-generator-prompt"
          (onChange)="selectModel($event)"
          [key]="form.value.model"
          [switcherStyle]="'light'"
          [round]="true"
        >
          <div *appSwitcherItem="'fast'" [class.active]="form.value.model === 'fast'" class="mode-switcher-item">
            <span>Fast</span>
          </div>
          <div *appSwitcherItem="'ultra'" [class.active]="form.value.model === 'ultra'" class="mode-switcher-item">
            <span>Ultra</span>
          </div>
        </app-switcher>

        <app-switcher
          class="aspect-ratio-switcher"
          name="aspect-ratio"
          location="image-generator-prompt"
          (onChange)="form.controls.aspectRatio.setValue($event)"
          [key]="form.value.aspectRatio"
          [switcherStyle]="'light'"
          [inputStyle]="'exact'"
          [round]="true"
        >
          <div *appSwitcherItem="'1:1'" [class.active]="form.value.aspectRatio === '1:1'" class="mode-switcher-item">
            <div class="aspect-ratio ratio-1-1"></div>
          </div>
          <div *appSwitcherItem="'2:3'" [class.active]="form.value.aspectRatio === '2:3'" class="mode-switcher-item">
            <div class="aspect-ratio ratio-2-3"></div>
          </div>
          <div *appSwitcherItem="'3:2'" [class.active]="form.value.aspectRatio === '3:2'" class="mode-switcher-item">
            <div class="aspect-ratio ratio-3-2"></div>
          </div>
        </app-switcher>

        <div class="spacer"></div>

        <app-badge color="primary" icon="/assets/icons/spark.svg">
          <span>{{ creditCost() }}</span>
        </app-badge>

        <button
          appButton
          name="confirm"
          location="image-generator-prompt"
          color="primary"
          shape="round"
          spacing="3"
          height="1"
          appTooltip="Generate"
          [tooltipKeyboardShortcut]="'Enter'"
          [tooltipKeyboardShortcutMeta]="true"
        >
          <span [class.hidden-text]="generating()">Imagine</span>
          @if (generating()) {
            <app-loading-indicator color="white" size="small" class="button-loading-indicator"> </app-loading-indicator>
          }
        </button>
      </div>

      <button
        class="close-button"
        appButton
        name="close"
        location="image-generator-prompt"
        [iconButton]="true"
        shape="round"
        color="simple-gray"
        (click)="close()"
      >
        <app-svg src="/assets/icons/cross.svg"></app-svg>
      </button>
    </form>
  </div>
</div>
